import { SET_CREATE_CLIENT_FROM, SET_ACTIVE_TAB } from './actionTypes'

export interface SetCreateClientFromType {
  type: string
  data: { from: string }
}

export const setCreateClientFrom = (from: string): SetCreateClientFromType => ({
  type: SET_CREATE_CLIENT_FROM,
  data: { from }
})

export interface SetActiveTabType {
  type: string
  tabName: string
}

export const setActiveTab = (tabName: string): SetActiveTabType => ({
  type: SET_ACTIVE_TAB,
  tabName
})
